import { useState, useEffect } from "react";

/**
 * Hook to select appropriate image based on screen size
 * @param mobileImage - Image source for mobile devices
 * @param desktopImage - Image source for desktop devices
 * @param breakpoint - Custom breakpoint in pixels (default: 1200 to match $mobile-breakpoint)
 * @returns The appropriate image source based on current screen size
 */
export const useResponsiveImage = (
  mobileImage: string,
  desktopImage: string,
  breakpoint = 512
): string => {
  const [isDesktop, setIsDesktop] = useState(() => {
    // Initialize with actual window width
    return typeof window !== 'undefined' ? window.innerWidth >= breakpoint : false;
  });

  useEffect(() => {
    const checkWidth = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };

    // Check on mount
    checkWidth();

    // Listen for resize events
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, [breakpoint]);

  return isDesktop ? desktopImage : mobileImage;
};
